module.exports = __webpack_public_path__ + "img/u530.7b6a6530.png";